import { render, staticRenderFns } from "./TariffsInfo.vue?vue&type=template&id=1bfacfdd&scoped=true"
import script from "./TariffsInfo.vue?vue&type=script&lang=js"
export * from "./TariffsInfo.vue?vue&type=script&lang=js"
import style0 from "./TariffsInfo.vue?vue&type=style&index=0&id=1bfacfdd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfacfdd",
  null
  
)

export default component.exports